import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCatalog({ payload }) {
  try {
    const res = yield call(API.fetchAllAvaiblaeTestsToAdd, payload);
    const { data } = res;
    yield put(actions.fetchCatalogSuccess(data));
  } catch (err) {
    yield put(actions.fetchCatalogFailure(err?.response?.data));
  }
}

export function* handleFetchFilters({ payload }) {
  try {
    const res = yield call(API.fetchFilters, payload);
    const { data } = res;
    yield put(actions.fetchFiltersSuccess(data));
  } catch (err) {
    yield put(actions.fetchFiltersFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyCatalog({ payload }) {
  try {
    const res = yield call(API.fetchCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.fetchCompanyCatalogSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyCatalogFailure(err?.response?.data));
  }
}

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(API.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleUpdateCatalog({ payload }) {
  try {
    const res = yield call(API.updateCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.updateCatalogSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateCatalogFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateCatalogFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleFetchCompanyDetails({ payload }) {
  try {
    const res = yield call(API.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCommodityCategories({ payload }) {
  try {
    const res = yield call(API.fetchAllCommodityCategories, payload);
    const { data } = res;
    yield put(actions.fetchCommodityCategoriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommodityCategoriesFailure(err?.response?.data));
  }
}

export function* handleFetchCommodity({ payload }) {
  try {
    const res = yield call(API.fetchAllTestCommodities, payload);
    const { data } = res;
    yield put(actions.fetchCommoditySuccess(data));
  } catch (err) {
    yield put(actions.fetchCommodityFailure(err?.response?.data));
  }
}

export function* handleFetchTestCategory({ payload }) {
  try {
    const res = yield call(API.fetchAllTestCategories, payload);
    const { data } = res;
    yield put(actions.fetchTestCategorySuccess(data));
  } catch (err) {
    yield put(actions.fetchTestCategoryFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* companyCatalogAddSaga() {
  yield takeLatest(actions.fetchCatalog.type, handleFetchCatalog);
  yield takeLatest(actions.fetchFilters.type, handleFetchFilters);
  yield takeLatest(actions.fetchCompanyCatalog.type, handleFetchCompanyCatalog);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeLatest(actions.updateCatalog.type, handleUpdateCatalog);
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompanyDetails);
  yield takeLatest(
    actions.fetchCommodityCategories.type,
    handleFetchCommodityCategories
  );
  yield takeLatest(actions.fetchCommodity.type, handleFetchCommodity);
  yield takeLatest(actions.fetchTestCategory.type, handleFetchTestCategory);
}
